export default "__VITE_ASSET__N45F8A7M__"